GP.vent.on('init_js:user:help', function(self) {

    if ((typeof section !== 'undefined') && (section !== '')) {
        if ( (MoshPit.get_size() == 'mobile') || (MoshPit.get_size() == 'tablet') ) {
            $('#help-left-col').hide();
            $('#help-right-col').show();
            $('#help-right-col #help-return').show();
        }
        $('#help-right-col #' + section).show();
    } else {
        if ( (MoshPit.get_size() == 'desktop') || (MoshPit.get_size() == 'desktop-wide') ) {
            $('#help-right-col #top').show();
        }
    }

    $(window).resize(function() {
        // adjust to mobile view
        if ( (MoshPit.get_size() == 'mobile') || (MoshPit.get_size() == 'tablet') ) {
            if ( $('#help-left-col').is(':visible') && $('#help-right-col > div').is(':visible') ) {
                $('#help-left-col').hide();
                $('#help-right-col #help-return').show();
            }
        // adjust to desktop view
        } else if ( (MoshPit.get_size() == 'desktop') || (MoshPit.get_size() == 'desktop-wide') ) {
            $('#help-left-col').show();
            $('#help-right-col #help-return').hide();
            if ( $('#top').is(':visible') )
            {
                if ( $('#profile').is(':visible')   ||
                     $('#general').is(':visible')   ||
                     $('#technical').is(':visible') ||
                     $('#billing').is(':visible')   ||
                     $('#video').is(':visible')     ||
                     $('#gallery').is(':visible')   ||
                     $('#cam').is(':visible')       ||
                     $('#sex').is(':visible')       ||
                     $('#fraud').is(':visible')     ||
                     $('#cs').is(':visible') )
                {
                     $('#top').hide();
                }
            }
        }
        return true;
    });

    self.display_help_page = function() {
        if (!this.id) {
            return;
        }

        var page = '';
        // mobile view
        if ( (MoshPit.get_size() == 'mobile') || (MoshPit.get_size() == 'tablet') ) {
            if ($(this).hasClass('help-cs') || $(this).hasClass('help-fraud')) {
                $('#help-right-col > div').hide();
            }
            $('#help-left-col').hide();
            $('#help-return').show();
        // desktop view
        } else if ( (MoshPit.get_size() == 'desktop') || (MoshPit.get_size() == 'desktop-wide') ) {
            $('#help-right-col > div').hide();
            window.scrollTo(0, 0);
        }

        $('#help-left-col li').removeClass();

        if ($(this).hasClass('help-cs')) {
            page = '#cs';
            $('#help-left-col #help-cs').addClass('active');
        } else if ($(this).hasClass('help-fraud')) {
            page = '#fraud';
            $('#help-left-col #help-fraud').addClass('active');
        } else {
            page = '#' + (this.id).replace('help-', '');
            $(this).addClass('active');
        }

        $(page).show();
    };

    self.toggle_paragraphs = function() {
        var t = '#' + (this.id) + 'a';
        $(t).toggle();
    };

    $('#help-content').on("click", "#help-left-col li", self.display_help_page);
    $('#help-content').on("click", "#help-right-col .help-cs", self.display_help_page);
    $('#help-content').on("click", "#help-right-col .help-fraud", self.display_help_page);
    $('#help-content').on("click", "#help-right-col p", self.toggle_paragraphs);
});
